<template>
  <div id="customer-view-tab-container">
    <button
      type="button"
      :class="[
        activeTab === 'table' ? 'active' : '',
        'tab',
      ]"
      @click="changeTab('table')"
    >
      <img
        v-if="activeTab === 'table'"
        src="@shared/assets/img/table/table-active.svg"
        alt="Cycle Table"
      >
      <img
        v-else
        src="@shared/assets/img/table/table.svg"
        alt="Cycle Table"
      >
    </button>
    <button
      type="button"
      :class="[
        activeTab === 'chart' ? 'active' : '',
        'tab',
      ]"
      @click="changeTab('chart')"
    >
      <img
        v-if="activeTab === 'chart'"
        src="@shared/assets/img/table/chart-active.svg"
        alt="Cycle Chart"
      >
      <img
        v-else
        src="@shared/assets/img/table/chart.svg"
        alt="Cycle Chart"
      >
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ViewTab',
  computed: {
    ...mapState({
      detailTab: (state) => state.customerDetail.activeTab,
      activeTab: (state) => state.customerDetail.cycleViewTab,
      hvac: (state) => state.customerDetail.hvac,
    }),
  },
  methods: {
    changeTab(tab) {
      if (tab === 'chart' || tab === 'scatter') {
        this.$store.dispatch(
          'setDetailCycleFilter',
          {
            field: 'uId',
            value: this.hvac[0].uId,
          },
        );
      }

      this.$store.dispatch(
        'changeCustomerDetailValue',
        {
          field: 'cycleViewTab',
          value: tab,
        },
      );
    },
  },
};
</script>

<style lang="scss">

#customer-view-tab-container {
  display: flex;

  .tab {
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $WHITE;
    border-radius: 2px;
    margin-left: 6px;
    cursor: pointer;

    &.active {
      background-color: $PRIMARY;
    }

    img {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
